import { render } from "./ObjectDataStep.vue?vue&type=template&id=ba65d1a4"
import script from "./ObjectDataStep.vue?vue&type=script&lang=js"
export * from "./ObjectDataStep.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__